import React, { PureComponent } from 'react'
import 'lib/proj4hack'
import Highcharts from 'highcharts'
import HighchartsReact from "highcharts-react-official"
import HighchartsMap from "highcharts/modules/map"
import mapData from "@highcharts/map-collection/custom/world.geo.json"
HighchartsMap(Highcharts); // initialize the map module

// To use MapView, pass in the following props:
//

class MapView extends PureComponent {
  constructor(props) {
    super(props);
    this.reboundChart = this.reboundChart.bind(this);
    this.resetChart = this.resetChart.bind(this);
    this.clickedSeries = this.clickedSeries.bind(this);
    this.clickedOutsideSeries = this.clickedOutsideSeries.bind(this);
    this.getCurrentViewData = this.getCurrentViewData.bind(this);
  }

  zoomLevel = 1;
  highZoomLevel = 0.1;
  

  reboundChart(x,y) {
    if (!this.chart) {
      return;
    }
    if (this.zoomLevel === 1) {
      console.debug("Rebounding map ... awaiting data");
      this.chart.mapZoom(this.highZoomLevel,this.chart.xAxis[0].toValue(x),this.chart.yAxis[0].toValue(y),x,y);
      this.zoomLevel = this.highZoomLevel;
      this.getCurrentViewData();
    }
  }

  getCurrentViewData() {
    let sw = this.chart.transformToLatLon({x:this.chart.xAxis[0].min,y:this.chart.yAxis[0].max},this.chart.mapTransforms.default);
    let ne = this.chart.transformToLatLon({x:this.chart.xAxis[0].max,y:this.chart.yAxis[0].min},this.chart.mapTransforms.default);
    this.props.seriesClickCallback(sw,ne);
  }

  resetChart()
  {
    if (this.zoomLevel !== 1) {
      console.debug("Rebounding map to default ... awaiting data");
      this.chart.mapZoom();
      this.zoomLevel = 1;
      this.props.seriesClickCallback(
          {lat: -90, lon: -180},{lat:90, lon: 180}
        );
    }
  }

  clickedSeries(event) {
    if (!event.point || !event.point.marker) {
      return;
    }
    // click event bubbles multiple times, make sure we process just one
    this.reboundChart(event.point.plotX, event.point.plotY);
  }

  clickedOutsideSeries(event) {
    this.resetChart();
  }
  
  getOptions() {
    let bgColor = this.props.isDarkMode ? "#010001" : "#ffffff";
    let fgColor = this.props.isDarkMode ? "#191819" : "#e7e6e7";
    return {
      title: {
        text: ''
      },
      legend: {
        enabled: false
      },
      chart: {
        backgroundColor: bgColor,
        panning: false,
        events: {
          click: (event) => {this.clickedOutsideSeries(event)}
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: "mapProjection",
          mapData: mapData,
          borderColor: fgColor,
          nullColor: fgColor,
        }, 
        {
          name: "Calls",
          type: 'mapbubble',
          dataLabels: {
            enabled: true,
            format: '{point.z}'
          },
          data: this.props.data,
//          maxSize: "12%",
          color: "#4f98fd", // unselected is 98c5ff if something is selected
          events: {
            click: (event) => {this.clickedSeries(event)}
          }
        }
      ],
      mapNavigation: {
        enabled: false
      }
    };
  }

  componentDidMount() {
    this.chart = this.refs.chartComponent.chart;
  }

  render() {
    return(
      <div>
        <HighchartsReact
        ref={"chartComponent"}
          constructorType={"mapChart"}
          highcharts={Highcharts}
          options={this.getOptions()}
        />
      </div>
    )
  }
}

export default MapView;
